import { Customizer } from "@fluentui/react";
import { getTheme, mergeStyleSets } from "@uifabric/styling";
import {
  DirectionalHint,
  IStyleSet,
  TooltipHost,
} from "office-ui-fabric-react";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppStoreState } from "store/AppStore";

type Props = {
  children: React.ReactNode;
  tooltipText?: string;
  isTooltipHidden?: boolean;
  isReadOnly?: boolean;
  styles?: IStyleSet;
};
const customize = {
  Tooltip: {
    styles: {
      root: {
        border: "1px solid #eeeeee",
      },
    },
  },
};
export const FieldContainer = ({
  tooltipText,
  isTooltipHidden,
  children,
  isReadOnly,
  styles,
}: Props) => {
  // const theme = getTheme();
  const appContext = useAppStoreState();
  const { t } = useTranslation();

  const defaultStyles = {
    root: {
      marginBottom: isReadOnly ? 0 : 10, //theme.spacing.m,
    },
  };
  // const [tooltipsStatus, setTooltipsStatus] = useLocalStorage(
  //   "tooltipsStatus",
  //   false
  // );

  const hidden = useMemo(() => {
    return isTooltipHidden || !appContext.appState.headerConfig.tooltipsStatus;
  }, [isTooltipHidden, appContext.appState.headerConfig.tooltipsStatus]);

  const classNames = styles
    ? mergeStyleSets(defaultStyles, styles)
    : (mergeStyleSets(defaultStyles) as any);
  let tooltipTranslatedText = t(tooltipText?.replaceAll(".label", ".tooltip"));
  if (tooltipTranslatedText.includes(".tooltip")) {
    return <div className={classNames.root}>{children}</div>;
  }
  return (
    <div className={classNames.root}>
      <Customizer scopedSettings={customize}>
        <TooltipHost
          content={tooltipTranslatedText}
          directionalHint={DirectionalHint.rightCenter}
          hidden={hidden}
        >
          {children}
        </TooltipHost>
      </Customizer>
    </div>
  );
};
